<template>
    <div class="columns is-centered">
        <div class="column is-one-third hr-tile">
            <ForgotPassword></ForgotPassword>
        </div>
    </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import ForgotPassword from '@/components/Auth/ForgotPassword.vue'

@Component({
  components: {
      ForgotPassword
  },
})
export default class Login extends Vue 
{
    created() {
        if(this.$store.state.auth.isAuthenticated) {
            this.$router.push("/");
        }
    }
}
</script>
